export default __webpack_public_path__ + "media/images/cta_blocks/create_wedding_website-3de8b1680181c384d8eca559d23891f4.jpg";